"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _buildXYAxes = _interopRequireDefault(require("./buildXYAxes"));
var _configureXYPlot = _interopRequireDefault(require("./configureXYPlot"));
var _layoutXYChart = _interopRequireDefault(require("./layoutXYChart"));
/**
 * Helper for building and composing a Plottable bar chart from Plottable Plot,
 * Axis, and Scale components.
 */
var buildXYChart = function buildXYChart(_ref) {
  var isAxisInverted = _ref.isAxisInverted,
    disableAutorangeMode = _ref.disableAutorangeMode,
    isCategorical = _ref.isCategorical,
    isTimeSeries = _ref.isTimeSeries,
    xAxisDomain = _ref.xAxisDomain,
    yAxisDomain = _ref.yAxisDomain,
    buildCustomAxes = _ref.buildCustomAxes,
    plot = _ref.plot,
    xValue = _ref.xValue;
  /**
   * Builds Plottable Axis and Scale components. Not to be confused with xAxis and
   * yAxis from React props.
   */
  var buildAxesHandler = typeof buildCustomAxes === 'function' ? buildCustomAxes : _buildXYAxes["default"];
  var _buildAxesHandler = buildAxesHandler({
      isAxisInverted: isAxisInverted,
      isCategorical: isCategorical,
      isTimeSeries: isTimeSeries,
      xAxisDomain: xAxisDomain,
      yAxisDomain: yAxisDomain
    }),
    xAxis = _buildAxesHandler.xAxis,
    xScale = _buildAxesHandler.xScale,
    yAxis = _buildAxesHandler.yAxis,
    yScale = _buildAxesHandler.yScale;
  var configuredPlot = (0, _configureXYPlot["default"])({
    isAxisInverted: isAxisInverted,
    disableAutorangeMode: disableAutorangeMode,
    xScale: xScale,
    xValue: xValue,
    yScale: yScale
  }, plot);
  var plottableXYChart = (0, _layoutXYChart["default"])({
    isAxisInverted: isAxisInverted,
    plot: configuredPlot,
    xAxis: xAxis,
    yAxis: yAxis
  });
  return plottableXYChart;
};
var _default = exports["default"] = buildXYChart;
//# sourceMappingURL=buildXYChart.js.map